import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { ensureExists } from '~/utils'

import { pathKey } from '../utils'

export const useSurveyId = () => {
  const { t } = useTranslation()
  const { surveyId } = usePathParams(pathKey)

  return ensureExists(surveyId, t('assertion_failed'))
}
